export function getCapacityColor(itemCapacity) {
    if (!itemCapacity) {
        return;
    }

    const capacity = itemCapacity.available - itemCapacity.absence - itemCapacity.planned;
    if (capacity < 0) {
        return '#FFCCCC';
    }

    if (itemCapacity.available === 0 || itemCapacity.available - itemCapacity.absence === 0) {
        return '#aaa';
    }
    const timeToWork = itemCapacity.available - itemCapacity.absence;
    const capacityPercentage = itemCapacity.planned / timeToWork;
    if (capacityPercentage === 1) {
        return '#BBFFDD';
    }
    if (capacityPercentage > 0.8 && capacityPercentage < 1) {
        return '#99FF99';
    }
}
